module.exports = __webpack_public_path__ + "assets/img/preload_curations.6bdee043.svg";